const angular = require('angular');
import { consent } from '../consent/consent-bootstrap';
const app = angular.module('learn-services');
app.factory('AnalyticsProvider', ['$window', function($window) {
    var self = this;
    var initializedMeasurementId = null;

    // Google's documented kill switch: stops the tag entirely (including
    // cookieless pings); flipping it back resumes without re-running config.
    var setGADisabled = function(measurementId, disabled) {
      $window['ga-disable-' + measurementId] = disabled;
    };

    // The consent banner syncs without a reload, so a loaded tag would keep
    // collecting after an analytics revoke — cc:onChange is vanilla-cookieconsent's
    // window event for any consent change.
    $window.addEventListener('cc:onChange', function() {
      self.AnalyticsProvider.updateCustomerGAConsent(consent.accepted('analytics'));
    });

    self.AnalyticsProvider = {
      init: function() {
      },
      updateCustomerGAConsent: function(allowed) {
        if (initializedMeasurementId) {
          setGADisabled(initializedMeasurementId, !allowed);
        }
      },
      // Initializes the customer's own Google Analytics property
      // (company.google_analytics) via gtag.js — accepts both G- and UA- ids.
      // send_page_view is off: trackPageView drives all pageviews so route
      // changes and the initial load are counted exactly once.
      initCustomerGA: function(measurementId) {
        if (!measurementId || measurementId === initializedMeasurementId || !consent.accepted('analytics')) {
          return;
        }
        if (initializedMeasurementId) {
          // Id changed mid-session; a loaded tag can't be unloaded, so
          // silence it before configuring the new one.
          setGADisabled(initializedMeasurementId, true);
        }
        initializedMeasurementId = measurementId;
        setGADisabled(measurementId, false);

        $window.dataLayer = $window.dataLayer || [];
        $window.gtag = $window.gtag || function() {
          $window.dataLayer.push(arguments);
        };

        var script = $window.document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
        $window.document.head.appendChild(script);

        $window.gtag('js', new Date());
        $window.gtag('config', measurementId, { send_page_view: false });
        // send_to keeps this hit off Continu's own tags (configured in
        // index.html), which already saw this page via trackPageView.
        $window.gtag('event', 'page_view', {
          send_to: measurementId,
          page_path: $window.location.hash.replace(/^#/, '') || '/',
          page_location: $window.location.href,
          page_title: $window.document.title
        });
      },
      trackPageView: function(path) {
        try {
          if (consent.accepted('analytics') && $window.gtag) {
            $window.gtag('event', 'page_view', {
              page_path: path,
              page_location: $window.location.href,
              page_title: $window.document.title
            });
          }
        } catch (e) {
          console.error(e.message, e.name);
        }
      },
      setUserInfo: function(userAuthToken) {
        try {
          var user = userAuthToken.user;
          var company = userAuthToken.company;
          if (consent.accepted('analytics')) {
            $window.plantrack.identify(user._id, {
              email: user.email,
              name: user.first_name + ' ' + user.last_name,
              companyId: company._id
            });

            $window.gtag('set', {'user_id': user.email});
          }

        } catch (e) {
          console.error(e.message, e.name);
        }
      },
      trackEvent: function(event, attributes) {

        try {
          //planhat
          if (consent.accepted('analytics')) {
            $window.plantrack.track(event);
          }
          //newrelic
          newrelic.addPageAction(event, attributes);
        } catch (e) {
          console.error(e.message, e.name);
        }
      }
    };
    return self.AnalyticsProvider;
  }]);